// Single source of truth for the SalesPlanner per-user settings contract.
// Imported by both the frontend (NgRx state init, save projection) and the
// backend (DynamoDB defaults for the `salesPlanner` user-settings category).

export interface SalesPlannerUserAccessibilitySettings {
  theme: string;
  boldText: boolean;
  largeText: boolean;
  increaseContrast: boolean;
}

export interface SalesPlannerUserSettings {
  salesPeople: string[];
  range: number;
  rangePast: number;
  monthsOverdue: number;
  showAllServiceAppointments: boolean;
  defaultActivityTab: string;
  defaultProspectTab: string;
  activityListDisplayEmployee: string;
  accessibility: SalesPlannerUserAccessibilitySettings;
}

export const SALES_PLANNER_USER_SETTINGS_CATEGORY = 'salesPlanner';
export const SALES_PLANNER_USER_SETTINGS_SCHEMA_VERSION = 1;

export const SALES_PLANNER_USER_SETTINGS_DEFAULTS: SalesPlannerUserSettings = {
  salesPeople: [],
  range: 2,
  rangePast: 7,
  monthsOverdue: 1,
  showAllServiceAppointments: false,
  defaultActivityTab: 'A',
  defaultProspectTab: 'P',
  activityListDisplayEmployee: 'activitySalesperson',
  accessibility: { theme: 'light', boldText: false, largeText: false, increaseContrast: false },
};
